<template>
  <div class="autoticket">
    <a-modal
      v-model="open"
      :title="labels.autoGenerate"
      cancelText="Cancelar"
      @ok="handleOk"
      okText="Aceptar"
      width="300px"
    >
      <a-form-item
        :label="`${labels.amount}:`"
        :validateStatus="amountError ? 'error' : ''"
        :help="amountError"
      >
        <a-input
          v-model="monto"
          type="number"
          style="width: 100%"
          :min="7"
          :max="22225"
          :rules="'required'"
          :allowClear="true"
          :maxLength="4"
          :mask="'$####'"
          @input="validateAmount"
        />
      </a-form-item>
    </a-modal>
    <a-button @click="open = true" type="primary">{{ labels.auto }}</a-button>
  </div>
</template>
<script>
import labels from "@/utils/labels";
export default {
  data() {
    return {
      labels: { ...labels.buy.autoticket },
      plays: [],
      playTotals: null,
      monto: 7,
      open: false,
      amountError: null,
    };
  },
  methods: {
    triggerAutoticket() {},
    validateAmount() {
      // Validar que el monto esté dentro del rango de 7 a 22225
      if (this.monto < 7) {
        this.amountError = "El monto debe ser al menos 7.";
      } else if (this.monto > 22225) {
        this.amountError = "El monto no puede ser mayor a 22225.";
      } else {
        this.amountError = null;
      }
    },
    handleOk() {
      this.validateAmount();
      if (this.amountError) {
        console.error(this.amountError);
        return;
      }
      this.open = false;
      let amount = parseInt(this.monto);
      const numeros = new Set();
      while (numeros.size < 3) {
        const nuevoNumero = String(Math.floor(Math.random() * 100)).padStart(
          2,
          "0"
        );
        numeros.add(nuevoNumero);
      }

      const [num1, num2, num3] = [...numeros].sort();

      const combinations = [
        { numbers: `${num1}`, amount: 0, type: "quiniela" },
        { numbers: `${num2}`, amount: 0, type: "quiniela" },
        { numbers: `${num3}`, amount: 0, type: "quiniela" },
        { numbers: `${num1}-${num2}`, amount: 0, type: "pale" },
        { numbers: `${num1}-${num3}`, amount: 0, type: "pale" },
        { numbers: `${num2}-${num3}`, amount: 0, type: "pale" },
        {
          numbers: `${num1}-${num2}-${num3}`,
          amount: 0,
          type: "tripleta",
        },
      ];

      this.distributeAmount(combinations, amount);
    },
    distributeAmount(combinations, amount) {
      const limites = {
        quiniela: { min: 1, max: 7000 },
        pale: { min: 1, max: 400 },
        tripleta: { min: 1, max: 25 },
      };

      const categorias = {
        quiniela: combinations.filter((o) => o.type === "quiniela"),
        pale: combinations.filter((o) => o.type === "pale"),
        tripleta: combinations.filter((o) => o.type === "tripleta"),
      };

      let montoAsignado = 0;
      combinations.forEach((obj) => {
        obj.amount = limites[obj.type].min;
        montoAsignado += obj.amount;
      });
      let montoRestante = amount - montoAsignado;

      let percentages = this.percentage(montoRestante);

      while (percentages.parte10 > 0) {
        for (const obj of categorias.tripleta.reverse()) {
          if (percentages.parte10 <= 0) break;

          const maximoObjeto = limites[obj.type].max - obj.amount;
          if (maximoObjeto > 0) {
            obj.amount += 1;
            percentages.parte10 -= 1;
          } else {
            percentages.parte20 += 1;
            percentages.parte10 -= 1;
          }
        }
      }

      while (percentages.parte20 > 0) {
        for (const obj of categorias.pale.reverse()) {
          if (percentages.parte20 <= 0) break;

          const maximoObjeto = limites[obj.type].max - obj.amount;
          if (maximoObjeto > 0) {
            obj.amount += 1;
            percentages.parte20 -= 1;
          } else {
            percentages.parte70 += 1;
            percentages.parte20 -= 1;
          }
        }
      }

      while (percentages.parte70 > 0) {
        for (const obj of categorias.quiniela.reverse()) {
          if (percentages.parte70 <= 0) break;

          const maximoObjeto = limites[obj.type].max - obj.amount;
          if (maximoObjeto > 0) {
            obj.amount += 1;
            percentages.parte70 -= 1;
          } else {
            percentages.parte70 -= 1;
          }
        }
      }

      combinations.forEach((element) => {
        this.$emit("handleAddPlay", element);
      });
    },
    percentage(numero) {
      let parte70 = Math.floor(numero * 0.7);
      let parte20 = Math.floor(numero * 0.2);
      let parte10 = Math.floor(numero * 0.1);

      let residuo = numero - (parte70 + parte20 + parte10);

      let partes = [parte70, parte20, parte10];
      for (let i = 0; residuo > 0; i++) {
        partes[i % 3]++;
        residuo--;
      }

      return {
        parte70: partes[0],
        parte20: partes[1],
        parte10: partes[2],
      };
    },
    generateNumber() {
      return String(Math.floor(Math.random() * 100)).padStart(2, "0");
    },
  },
};
</script>

<style scoped>
.autoticket {
  display: flex;
  justify-content: flex-end;

  .autoticket-compact {
    display: flex;
    justify-content: flex-end;
  }
}

::v-deep .ant-modal-header {
  background: var(--modal-bg);
  color: var(--text);
}

::v-deep .ant-modal-title {
  color: var(--text) !important;
}

::v-deep .ant-modal-close-icon {
  color: var(--text) !important;
}

::v-deep .ant-modal-body {
  background: var(--modal-bg);
  color: var(--text);
}

::v-deep .ant-btn-primary {
  background: var(--btn-bg-secondary);
  color: var(--btn-text-secondary);
  border: 1px solid var(--btn-bc-secondary);
  border-radius: 0;
  &:hover,
  &:focus {
    background: var(--btn-bg-secondary);
    color: var(--btn-text-secondary);
    border: 1px solid var(--btn-bc-secondary);
  }
}

::v-deep label {
  color: var(--text) !important;
}

::v-deep .ant-modal-footer {
  background: var(--modal-bg);
  color: var(--text);
}
</style>
